$( document ).ready(function() {
    if ( $(window).width() < 767 ) {
        $('#shopify-section-sidebar-sort').insertBefore('.product_options');
        $('#shopify-section-sidebar-sort-ailments').insertBefore('.product_options');
    }

    // $(".quantity_input").change(function() {
    //     var price = parseFloat($("#").replace("$", ""));
    //     var newPrice = parseFloat(price * parseInt($(this).val()) / 100).toFixed(2);
    //     $('#single_product__price-template-product span.money').html("$" + newPrice);
    // });

});